<div class="flex flex-col space-y-3">
	<div class="flex flex-col space-y-1">
		<span>
			{{
				BASE_I18N_KEY + '.date'
					| translate
						: {
								name: (coachee$ | async)?.name,
								date: (coacheeDateTime$ | async)
						  }
			}}
		</span>
		<p-calendar
			[inputStyle]="{ width: '100%' }"
			[locale]="'presentation.primeng.calendar' | translate"
			[maxDate]="maxDate"
			[minDate]="minDate"
			[monthNavigator]="true"
			[ngModel]="meetingDate$ | async"
			[readonlyInput]="false"
			[showTime]="true"
			[stepMinute]="15"
			[style]="{ width: '100%' }"
			(ngModelChange)="onMeetingDateChange($event)"
			appendTo="body"
			dateFormat="dd/mm/yy"
		></p-calendar>
	</div>
	<div class="flex flex-col space-y-1">
		<label>
			{{ BASE_I18N_KEY + '.module.label' | translate }}
		</label>
		<p-multiSelect
			[defaultLabel]="BASE_I18N_KEY + '.module.placeholder' | translate"
			[itemSize]="30"
			[maxSelectedLabels]="0"
			[options]="modules$ | async"
			[showToggleAll]="false"
			[style]="{ width: '100%' }"
			[virtualScroll]="true"
			(onChange)="onModulesIdSelected($event)"
			appendTo="body"
		></p-multiSelect>
	</div>
	<div class="self-end">
		<button
			*ngIf="!(isSaving$ | async)"
			[label]="BASE_I18N_KEY + '.add.label' | translate"
			(click)="onAddClick()"
			pButton
		></button>
		<p-progressSpinner
			*ngIf="isSaving$ | async"
			[style]="{ width: '50px', height: '50px' }"
		></p-progressSpinner>
	</div>
</div>
